module.exports = __webpack_public_path__ + "static/google-play-badge-56b446863643039c5c386e785054f8f8.svg";